var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1795_36358)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2038 20.4626H4.63176C3.20722 20.4626 2.04688 19.3043 2.04688 17.8777C2.04688 14.6947 6.74322 13.2109 9.9178 13.2109C13.0924 13.2109 17.7887 14.6947 17.7887 17.8756C17.7887 19.3044 16.6284 20.4626 15.2038 20.4626ZM9.9178 14.9039C7.39842 14.9039 3.73773 16.0621 3.73773 17.8777C3.73773 18.3702 4.1393 18.7717 4.63176 18.7717H15.2038C15.6963 18.7717 16.0979 18.3702 16.0979 17.8777C16.0979 16.0621 12.4372 14.9039 9.9178 14.9039Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91829 12.1791C7.2404 12.1791 5.0592 10 5.0592 7.32003C5.0592 4.64214 7.23829 2.46094 9.91829 2.46094C12.5983 2.46094 14.7774 4.64002 14.7774 7.32003C14.7774 10 12.5983 12.1791 9.91829 12.1791ZM9.91829 4.1539C8.17249 4.1539 6.75006 5.57422 6.75006 7.32214C6.75006 9.06795 8.17037 10.4904 9.91829 10.4904C11.6662 10.4904 13.0865 9.07006 13.0865 7.32214C13.0865 5.57422 11.6641 4.1539 9.91829 4.1539Z",
    fill: "#010101"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1795_36358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.0625 0.460938)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.c7f5d67a0378cd51f85bdbda2f7e34e5.svg";
export { ForwardRef as ReactComponent };